// extracted by mini-css-extract-plugin
export default {"androidAppPrompt":"styles_androidAppPrompt__pZUpv"};